<template>
   <div class="flex flex-col flex-wrap">
    <div class="w-full list-cards-row flex flex-row flex-wrap overflow-hidden">
    <swiper v-bind="getSwiperParameters" class="swiper-container">
        <swiper-slide v-for="(item, i) in dataCards" :key="i">
        <div class="w-full">
           <a :href="item.href" >
            <card-item :const-height="'600px'" :data-image="item.featured" />
           </a>
        </div>
        </swiper-slide>
   
    </swiper>
    </div>
    </div>
</template>

<script>
import { Swiper, SwiperSlide } from "swiper/vue";
import { Navigation, Virtual } from "swiper";

import "swiper/css/navigation";
import "swiper/css";
import "swiper/css/navigation";
import "../MySwiper.css";

export default {
    name: "carousel-cards",
    inject: ["mq"],
    components:{
        Swiper,
        SwiperSlide,
       
    },
    props: {
        dataCards: {
            type: Array,
            default: []
        }
    },
    mounted(){
        console.log(this.dataCards)
    },
    computed: {
        getSwiperParameters() {
            return {
                modules: [Navigation, Virtual],
                speed: 1200,
                slidesPerView:1,
                navigation: true,
                autoHeight: true,
                freemode:true,
                breakpoints:{
                    '1024':{
                        slidesPerView: 3,
                        spaceBetween:5,
                        height:500
                    },
                    '2560':{
                        slidesPerView:4,
                        spaceBetween: 5,
                        height: 600
                    }
                }
            }
        }
    }
}
</script>

<style lang="scss" scoped>

</style>